import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  sendPasswordResetEmail,
} from 'firebase/auth';
import { doc, collection, addDoc, serverTimestamp, writeBatch } from 'firebase/firestore';
import { auth, db } from './config';
import { logActivityEvent } from '../utils/activityClient';

export async function signUp({ email, password, role, name, phone, orgNumber, orgName }) {
  const { user } = await createUserWithEmailAndPassword(auth, email, password);

  const batch = writeBatch(db);

  batch.set(doc(db, 'users', user.uid), {
    uid: user.uid,
    roles: [role],
    driverStatus:  role === 'driver'  ? 'pending' : null,
    ...(role === 'driver' ? { languages: ['nb'] } : {}),
    // Bestillere trenger ikke godkjenning: betalingen sikres ved reservasjon i acceptBid.
    ordererStatus: role === 'orderer' ? 'active' : null,
    name,
    email,
    phone,
    orgNumber,
    orgName,
    stripeAccountId: null,
    stripeCustomerId: null,
    creditVerified: false,
    prepaymentRequired: role === 'orderer',
    isTestAccount: false,
    fcmToken: null,
    orgId: null,
    locationConsentAt: null,
    createdAt: serverTimestamp(),
  });

  if (role === 'orderer') {
    batch.set(doc(db, 'publicProfiles', user.uid), {
      name,
      companyName: orgName ?? '',
      orderCount: 0,
      bio: '',
      roles: ['orderer'],
      tippiVerified: false,
    });
  } else if (role === 'driver') {
    batch.set(doc(db, 'publicProfiles', user.uid), {
      name,
      orgName: orgName ?? '',
      phone: phone ?? '',
      orderCount: 0,
      roles: ['driver'],
      tippiVerified: false,
      languages: ['nb'],
    });
  }

  await batch.commit();
  return user;
}

export async function registerVehicle(driverUid, vehicleData) {
  await addDoc(collection(db, 'vehicles'), {
    driverUid,
    ...vehicleData,
    createdAt: serverTimestamp(),
  });
}

export async function logIn(email, password) {
  const credential = await signInWithEmailAndPassword(auth, email, password);
  logActivityEvent('login', { summary: 'Logget inn' }); // fire-and-forget
  return credential;
}

export async function logOut() {
  // Må skje før signOut (kallet krever innlogging), men skal ikke holde utloggingen igjen
  await Promise.race([
    logActivityEvent('logout', { summary: 'Logget ut' }),
    new Promise(resolve => setTimeout(resolve, 1500)),
  ]);
  return signOut(auth);
}

export async function resetPassword(email) {
  return sendPasswordResetEmail(auth, email);
}
